import _CircularProgress from "material-ui/CircularProgress";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import classNames from 'classnames';
import { variables } from 'swag-client-common/styles/variables-js';
import classes from './button.scss';
export let ButtonSize = /*#__PURE__*/function (ButtonSize) {
  ButtonSize["large"] = "large";
  ButtonSize["normal"] = "normal";
  ButtonSize["small"] = "small";
  ButtonSize["short"] = "short";
  ButtonSize["long"] = "long";
  ButtonSize["custom"] = "custom";
  return ButtonSize;
}({});
export let ButtonFontSize = /*#__PURE__*/function (ButtonFontSize) {
  ButtonFontSize["large"] = "large";
  ButtonFontSize["normal"] = "normal";
  ButtonFontSize["small"] = "small";
  return ButtonFontSize;
}({});
export let ButtonTextTransform = /*#__PURE__*/function (ButtonTextTransform) {
  ButtonTextTransform[ButtonTextTransform["uppercase"] = 0] = "uppercase";
  ButtonTextTransform[ButtonTextTransform["none"] = 1] = "none";
  return ButtonTextTransform;
}({});
export let ButtonType = /*#__PURE__*/function (ButtonType) {
  ButtonType["primary"] = "primary";
  ButtonType["secondary"] = "secondary";
  ButtonType["grey"] = "grey";
  ButtonType["fullGrey"] = "fullGrey";
  ButtonType["fullGreyGreyText"] = "fullGreyGreyText";
  ButtonType["transparent"] = "transparent";
  ButtonType["default"] = "default";
  ButtonType["white"] = "white";
  ButtonType["green"] = "green";
  ButtonType["enterprise"] = "enterprise";
  ButtonType["standard"] = "standard";
  ButtonType["starter"] = "starter";
  ButtonType["defaultGrey"] = "defaultGrey";
  ButtonType["danger"] = "danger";
  ButtonType["primaryOutlined"] = "primary-outlined";
  ButtonType["secondaryOutlined"] = "secondary-outlined";
  ButtonType["whiteUnderlined"] = "whiteUnderlined";
  ButtonType["alternativePrimary"] = "alternativePrimary";
  ButtonType["alternativePrimaryOutlined"] = "alternativePrimaryOutlined";
  ButtonType["outlineMonochrome"] = "outlineMonochrome";
  ButtonType["transparentBackgroundGreyText"] = "transparentBackgroundGreyText";
  return ButtonType;
}({});
const getFontSizeClass = fontSize => {
  const sizes = {
    [ButtonFontSize.large]: classes.fontSizeLarge,
    [ButtonFontSize.normal]: classes.fontSizeNormal,
    [ButtonFontSize.small]: classes.fontSizeSmall
  };
  return sizes[fontSize] || '';
};
export const Button = props => {
  const {
    onClick,
    children,
    type,
    size,
    disabled = false,
    applyDisabledStyles = false,
    loading = false,
    className,
    name = '',
    style,
    formType,
    dataCallback,
    dataButton,
    isButtonTag = true,
    textTransform = ButtonTextTransform.uppercase,
    fontSize
  } = props;
  let buttonType;
  switch (type) {
    case ButtonType.primary:
    case ButtonType.secondary:
    case ButtonType.grey:
    case ButtonType.fullGrey:
    case ButtonType.fullGreyGreyText:
    case ButtonType.transparent:
    case ButtonType.default:
    case ButtonType.white:
    case ButtonType.green:
    case ButtonType.enterprise:
    case ButtonType.standard:
    case ButtonType.starter:
    case ButtonType.defaultGrey:
    case ButtonType.danger:
    case ButtonType.primaryOutlined:
    case ButtonType.secondaryOutlined:
    case ButtonType.whiteUnderlined:
    case ButtonType.alternativePrimary:
    case ButtonType.alternativePrimaryOutlined:
    case ButtonType.outlineMonochrome:
    case ButtonType.transparentBackgroundGreyText:
      buttonType = classes[type];
      break;
    default:
      {
        const defaultClassName = 'default';
        buttonType = classes[defaultClassName];
        break;
      }
  }
  let buttonSize;
  switch (size) {
    case ButtonSize.large:
    case ButtonSize.normal:
    case ButtonSize.small:
    case ButtonSize.short:
    case ButtonSize.custom:
    case ButtonSize.long:
      buttonSize = classes[size];
      break;
    default:
      buttonSize = classes.normal;
      break;
  }
  const buttonClasses = classNames(classes.button, buttonType, buttonSize, {
    [classes.disabled]: disabled || applyDisabledStyles
  }, className);
  const fontSizeClass = fontSize ? getFontSizeClass(fontSize) : '';
  return /*#__PURE__*/React.createElement(RootElement, {
    isButtonTag: isButtonTag,
    onClick: onClick,
    className: buttonClasses,
    disabled: disabled,
    name: name,
    style: style,
    type: formType,
    "data-button": dataButton,
    "data-callback": dataCallback
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(fontSizeClass, {
      [classes.visible]: !loading,
      [classes.transformNone]: textTransform === ButtonTextTransform.none
    })
  }, children), /*#__PURE__*/React.createElement("div", {
    className: classNames({
      [classes.visible]: loading
    }, classes.overlay)
  }, /*#__PURE__*/React.createElement(_CircularProgress, {
    className: classes.loader,
    color: variables.colorWhite,
    size: 30
  })));
};
const RootElement = function (props) {
  const {
      isButtonTag,
      children
    } = props,
    rest = _objectWithoutProperties(props, ["isButtonTag", "children"]);
  return isButtonTag ? /*#__PURE__*/React.createElement("button", rest, children) : /*#__PURE__*/React.createElement("div", rest, children);
};